module.exports = __webpack_public_path__ + "assets/img/logo_black.dc72d4b7.png";